var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import useTable from './customHook/UseTable';
import styled from 'styled-components';
import { Paper, makeStyles, TableBody, Toolbar, Grid, } from '@material-ui/core';
import PageHeader from './components/pageHeader/PageHeader';
import Row from './components/row';
import SearchInput from 'tsf_search/dist/components/searchInput';
import CreateNew from '../../../common/createNew';
import EmptyList from '../emptyList';
var customStyles = makeStyles(function (theme) { return ({
    pageContent: {
        padding: theme.spacing(3),
        backgroundColor: 'transparent',
        boxShadow: 'none',
    },
    toolbarWrapper: {
        padding: '0px',
    },
    searchInput: {
        width: '250px',
        height: '48px',
        marginRight: '10px',
    },
    rightHeader: {
        textAlign: 'right',
        display: 'flex',
        float: 'right'
    },
    newButton: {
        position: 'absolute',
        right: '0px',
    },
}); });
var MaximizedList = function (_a) {
    var className = _a.className, title = _a.title, data = _a.data, columns = _a.columns, actions = _a.actions, showCreateNewButton = _a.showCreateNewButton, showSearchFeild = _a.showSearchFeild, collapsibleRow = _a.collapsibleRow, children = _a.children, rowClicked = _a.rowClicked, actionClicked = _a.actionClicked, handleCreateNew = _a.handleCreateNew, handleSearch = _a.handleSearch, handleChangePage = _a.handleChangePage, handleChangeRowsPerPage = _a.handleChangeRowsPerPage, handleSortRequest = _a.handleSortRequest;
    var classes = customStyles();
    var rowsPerPage = data.rowsPerPage, page = data.page, sortBy = data.sortBy, sortDirection = data.sortDirection, records = data.records;
    var _b = useTable({ data: data, columns: columns, collapsibleRow: collapsibleRow, handleChangePage: handleChangePage, handleChangeRowsPerPage: handleChangeRowsPerPage, handleSortRequest: handleSortRequest }), TblContainer = _b.TblContainer, TblHead = _b.TblHead, TblPagination = _b.TblPagination;
    var handleActionClicked = function (actionId, id) {
        if (actionClicked) {
            actionClicked(actionId, id);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Paper, { className: classes.pageContent + ' ' + className, elevation: 3 },
            React.createElement(Toolbar, { className: classes.toolbarWrapper },
                React.createElement(MaxTableGrid, { container: true },
                    React.createElement(Grid, { item: true, md: 5 },
                        React.createElement(PageHeader, { title: title ? title : '' })),
                    React.createElement(Grid, { item: true, md: 7 },
                        React.createElement("div", { className: classes.rightHeader },
                            showSearchFeild &&
                                React.createElement(SearchInput, { handleSearch: handleSearch }),
                            showCreateNewButton &&
                                React.createElement(CreateNew, { height: 48, handleCreateNew: handleCreateNew }))))),
            (!data || data && data.records.length === 0) && React.createElement(EmptyList, null),
            data && data.records.length > 0 && React.createElement(React.Fragment, null,
                " ",
                React.createElement(TblContainer, null,
                    React.createElement(TblHead, null),
                    React.createElement(TableBody, null, records &&
                        records.length > 0 &&
                        records.map(function (item) {
                            var id = item.id;
                            return (React.createElement(Row, { key: id, row: item, actions: actions, columns: columns, collapsibleRow: collapsibleRow, children: children, actionClicked: function (e) { return handleActionClicked(e, id); }, rowClicked: function () {
                                    return rowClicked ? rowClicked(item) : console.log(item);
                                } }));
                        }))),
                React.createElement(TblPagination, null)))));
};
export default MaximizedList;
var MaxTableGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .MuiGrid-item {\n        align-self: center;\n    }\n"], ["\n    .MuiGrid-item {\n        align-self: center;\n    }\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map